import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import DemoBanner from '../UI/DemoBanner';
import { useAppSelector } from '../../hooks/redux';

const Layout = () => {
  const { sidebarExpanded } = useAppSelector((state) => state.ui);
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  // Calculate main content margin based on sidebar state
  const mainMarginLeft = isAuthenticated ? (sidebarExpanded ? 'ml-80' : 'ml-20') : 'ml-0';

  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-neutral-50)]">
      <DemoBanner />
      <Header />
      <Sidebar />
      <main className={`flex-grow transition-all duration-300 ${mainMarginLeft}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
